export function selectSubstring(string, pattern) {
    const start = string.toLowerCase().indexOf(pattern.toLowerCase());
    if (start === -1) {
        return ['', string, ''];
    } else {
        return [
            string.substring(0, start),
            string.substring(start, start + pattern.length),
            string.substring(start + pattern.length)
        ];
    }
}

export function jsonParse(string, fallback) {
    try {
        return JSON.parse(string);
    } catch (e) {
        return fallback || string;
    }
}

export function validateEmail(email) {
    var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const bufferArrayToUtf8 = arr => {
    if (Array.isArray(arr)) {
        const decoder = new TextDecoder('utf-8');
        return decoder.decode(new Uint8Array(arr));
    } else {
        return '';
    }
};
